import getOverviewStats, { OverviewStats } from "../../../domain/use_cases/leedflow/overview/getOverviewStats";
import { useContext, useEffect, useState } from "react"
import { ContextStatus } from "@leedpulse-monorepo/enums";
import { Dayjs } from "dayjs";
import { ISubscription } from "@leedpulse-monorepo/interfaces";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

export const useLeedflowOverviewStats = (
    period?: [Dayjs | null, Dayjs | null],
    subscriptionIds?: string[],
    exclude?: string[],
) => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;
    const [stats, setStats] = useState<OverviewStats>({
        callsStats: {
            handledCalls: 0,
            answeredCalls: 0,
            missedCalls: 0,
            answerRate: 0,
            totalDurationSeconds: 0,
            averageDurationMinutes: 0,
            averageDurationSeconds: 0,
            totalCost: 0,
            coverage: { pricedCalls: 0, answeredCalls: 0 },
            faulty: { total: 0, byReason: {} },
            breakdown: { direction: {}, platform: {} },
        },
        smsStats: {
            sentCount: 0,
            receivedCount: 0,
            totalCost: 0,
            averageCost: 0,
            sentCost: 0,
            receivedCost: 0,
        },
        voicemailStats: {
            totalCount: 0,
            totalCost: 0,
        },
        costStats: {
            openaiCount: 0,
            openaiCost: 0,
            elevenlabsCount: 0,
            elevenlabsCost: 0,
        },
        topSubscriptions: { byCalls: [], byReceptionist: [], bySms: [], byCost: [] },
        lastCalls: [],
        lastSms: [],
        faultyCalls: [],
        deviceBreakdown: {},
        mapPoints: [],
        buckets: [],
    });
    const [status, setStatus] = useState<ContextStatus>(ContextStatus.IDLE);
    const [subscriptions, setSubscriptions] = useState<ISubscription[]>([]);
    const [subscriptionApiKeys, setSubscriptionApiKeys] = useState<string[]>([]);

    // Load overview stats (with period filter)
    useEffect(() => {
        if (!auth) return;
        (async () => {
            setStatus(ContextStatus.LOADING);
            try {
                const res = await getOverviewStats(auth, period, subscriptionIds, exclude);
                setStats(res);
                setSubscriptionApiKeys(res.subscriptionApiKeys);

                // Store subscriptions only on first load (when subscriptionIds is undefined)
                if (!subscriptionIds || subscriptionIds.length === 0) {
                    setSubscriptions(res.subscriptions);
                }

                setStatus(ContextStatus.SUCCESS);
            } catch (error) {
                console.error(error);
                setStatus(ContextStatus.ERROR);
            }
        })();
    }, [auth, period, subscriptionIds, exclude]);

    return {
        stats,
        status,
        subscriptions,
        subscriptionApiKeys,
    }
}